module.exports = __webpack_public_path__ + "img/littleImg09.be72230b.gif";